import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { PageContents } from "../DTOs/responses/pageContents";

type PageContentsResponse = AxiosResponse<PageContents[]>;

export const usePageContents = (
  pageId?: string,
): UseQueryResult<PageContents[]> => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchPageContents = (): Promise<PageContentsResponse> => {
    if (!pageId) {
      throw new Error("pageId is undefined");
    }

    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(
      `${process.env.REACT_APP_BASE_URL}/pages/contents/${pageId}`,
      {
        headers,
      },
    );
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["page-contents", pageId, language],
    queryFn: fetchPageContents,
    select: (data) => data.data,
  });
};
